import AbilityPane from './AbilityPane';

export default AbilityPane;
export { AbilityPane };
